
















import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Action } from 'vuex-class'
import Locale from '@/modules/i18n/model/Locale'
import { Prop } from 'vue-property-decorator'
import _ from 'lodash'
import { locale } from 'moment'

/**
 * Selector de localismos
 *
 * Muestra todos los localismos registrados en la aplicación y permite
 * seleccionar uno.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class LocaleSelectComponent extends Vue {
    /**
     * Lista con todos los localismo registrados en la aplicación
     */
    @State(state => state.i18n.locales)
    public appLocales: Locale[]

    @Action('i18n/loadLocales')
    public loadLocales: () => void

    @Prop()
    public filters: null | { policy: 'include' | 'exclude', identifiers: string[]}

    /**
     * Permite definir una función de filtrado
     */
    @Prop({type: Function, default: null})
    public filter: null | ((locales: Locale[]) => Locale[])

    @Prop({type: Boolean, default: false})
    public solo: boolean

    /**
     * Si se activa, impedirá al usuario seleccionar localismos
     */
    @Prop({type: Boolean, default: false})
    public disabled: boolean

    /**
     * Se se activa, el selector no cargará la lista de localismos hasta que se
     * invoque el método load
     */
    @Prop({type: Boolean})
    public manual: boolean

    /**
     * Localismo actualmente seleccionado
     */
    @Prop({type: [String, Locale], default: () => new Locale() })
    public value: Locale | string

    @Prop({type: String, default: ''})
    public label: string

    /**
     * Indica si el selector esta cargando la lista de mensajes
     */
    public loading = false

    /**
     * Localismo actualmente seleccionado
     */
    public get current (): Locale | null {
        return typeof this.value === 'string'
            ? this.appLocales.find(l => l.identifier === this.value) || null
            : this.value
    }

    /**
     * Proporciona la lista de idiomas al selector
     *
     * @returns {Locale[]}
     */
    get locales (): Locale[] {
        const locales = this.appLocales

        // Si se ha especificado una función de filtrado personalizada por el componente padre,
        // se utiliza este mecanismo de filtrado en lugar del objeto de configuración
        // de inclusión o exclusión de localismo
        const filterFn = this.filter
        if (filterFn) {
            return filterFn(locales)
        }

        const filters = this.filters
        if (!filters) {
            return locales
        }

        if (typeof filters === 'object') {
            return _.filter(locales, l => {
                const includes = _.includes(filters.identifiers, l.identifier)
                return filters.policy === 'exclude' ? !includes : includes
            })
        }

        return locales
    }

    public onSelect (locale: Locale) {
        this.$emit('select', locale)
    }

    public created () {
        if (!this.manual) {
            this.load()
        }
    }

    public async load () {
        this.loading = true
        await this.loadLocales()
        this.loading = false
    }
}
